import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import UIText from './uiText';
import { Button, Dropdown, Space, Tooltip } from 'antd';
import { DownOutlined, InfoCircleOutlined } from '@ant-design/icons';
import UIValue from './uiValue';
import UIValidation from './uiValidation';
function UISelectComponent(props) {
    const [selectedValue, setSelectedValue] = useState(props.value);
    const handleMenuClick = (e) => {
        setSelectedValue(e.key);
        props.onSelect(e.key);
    };
    const menuProps = {
        items: props.options.map((item) => ({ label: item, key: item })),
        onClick: handleMenuClick,
    };
    const marginRight = props.text ? '36px' : '0px';
    return (_jsxs("div", { style: { display: 'flex', marginBottom: '16px' }, children: [_jsxs("label", { style: {
                    marginRight: '16px',
                    whiteSpace: 'nowrap',
                    width: '140px',
                    textAlign: 'left',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: '10px',
                }, children: [props.title, props.text && (_jsx(Tooltip, { placement: "top", title: props.text, children: _jsx("div", { style: {
                                cursor: 'pointer',
                            }, children: _jsx(InfoCircleOutlined, { style: { cursor: 'pointer' } }) }) }))] }), _jsx("div", { className: 'flex items-center justify-end w-full relative overflow-hidden', children: _jsx(Dropdown, { menu: menuProps, className: `w-full`, children: _jsx(Button, { className: "w-full", children: _jsxs(Space, { className: 'flex w-full justify-between', children: [selectedValue || props.title, _jsx(DownOutlined, { style: { marginRight: marginRight } })] }) }) }) })] }));
}
export default class UISelect extends UIValue {
    title;
    text;
    options;
    onSelect;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        if ('text' in s) {
            this.text = new UIText(s);
        }
        this.options = [];
        this.value = '';
        if ('options' in s && s.options !== null) {
            for (const o of s.options && s.options) {
                this.options.push(o);
            }
        }
    }
    handleSelectionChange = (value) => {
        this.value = value;
        this.error = undefined;
        this.onSelect?.(value);
    };
    getComponent() {
        const props = {
            options: this.options,
            title: this.title,
            onSelect: this.handleSelectionChange,
            value: this.value,
            text: this.text !== undefined ? this.text.getComponent() : '',
        };
        return (_jsx(UIValidation, { error: this.error, children: _jsx(UISelectComponent, { ...props }) }));
    }
}
//# sourceMappingURL=uiSelect.js.map